import {RelayEnvironmentProvider, relayEnvironmentWithMissingFieldHandlerForNode} from '@github-ui/relay-environment'
import {useState} from 'react'
import type {Environment} from 'react-relay'

// We want to use a relative URL for the prod / staging / dev environments, but an absolute URL for jest tests
const baseUrl =
  process.env.APP_ENV === 'production' || process.env.APP_ENV === 'staging' || process.env.APP_ENV === 'development'
    ? undefined
    : 'http://memex.dev/_graphql'

export const RelayProvider: React.FC<{children: React.ReactNode; environment?: Environment}> = ({
  children,
  environment: providedEnvironment,
}) => {
  const [initialEnvironment] = useState(
    () => providedEnvironment ?? relayEnvironmentWithMissingFieldHandlerForNode(baseUrl),
  )
  const environment = providedEnvironment ?? initialEnvironment

  return <RelayEnvironmentProvider environment={environment}>{children}</RelayEnvironmentProvider>
}
